export enum AudioFileExtension {
  Mp3 = 'mp3',
  Wav = 'wav',
  Ogg = 'ogg',
  Mp4 = 'mp4',
  Flac = 'flac',
  Aac = 'aac',
}

export const audioFileExtensions: AudioFileExtension[] = Object.values(AudioFileExtension)
